import { WorkoutExercise, WorkoutSet } from '@strength/domain-workout';
import { MdNote } from '@teamworksdev/icons';
import { useTranslation } from 'react-i18next';
import { ContextMenuItem } from '../../../components/context-menu/context-menu';
import { ContextMenuItemIcon } from '../context-menu/context-menu-item-icon';
import { processDataForContextMenu } from '../context-menu/data-for-context-menu';
import { hasDisabledItem } from '../copy-paste/group-data';
import { BlockSelectionData, InstructionEditData } from '../types';
import { groupSelectionData } from './group-data';

interface ContextMenuProps {
  data: readonly BlockSelectionData[];
  setInstructionEditData: (data: InstructionEditData) => void;
}

export const ContextMenu = ({
  data,
  setInstructionEditData,
}: ContextMenuProps) => {
  const { t } = useTranslation();
  const groupedData = groupSelectionData(data);
  const disabledItemPresent = hasDisabledItem(groupedData);
  const pattern = processDataForContextMenu(groupedData);

  if (
    !pattern ||
    disabledItemPresent ||
    pattern.type !== 'oneEntity' ||
    pattern.data.type !== 'Set' ||
    !isSetWithInstruction(pattern.data.exercise, pattern.data.set)
  ) {
    return null;
  }

  const { set, exercise } = pattern.data;

  // Set the Instruction on the exercise for this set
  return (
    <>
      <ContextMenuItem
        onSelect={() => {
          setInstructionEditData({
            workoutId: pattern.workoutId,
            workoutSectionId: exercise.workoutSectionId,
            workoutExerciseId: set.workoutExerciseId,
            instruction: exercise.instruction,
          });
        }}
      >
        <ContextMenuItemIcon IconPath={MdNote} />
        {t('instruction')}
      </ContextMenuItem>
    </>
  );
};

const isSetWithInstruction = (exercise: WorkoutExercise, set: WorkoutSet) => {
  const deliveryTypeMetric = exercise.metrics.find(
    (m) => m.metricName === 'Delivery Type',
  );
  if (!deliveryTypeMetric) {
    return false;
  }
  // Sets that are for the Bowling metric 'Delivery Type' with the keyword 'Modified'
  // in a Prescription slot can set the instruction
  return exercise.sets.find((s) =>
    s.metrics.some(
      (m) =>
        m.input === 'Modified' && m.metricId === deliveryTypeMetric.metricId,
    ),
  );
};
